import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import LifestyleByImageImage from "../../../assets/ProductShot/images/api-lifestyle-by-image.png";
import LifestyleByTextImage from "../../../assets/ProductShot/images/api-lifestyle-by-text.png";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleComfyUILayout from "../../../components/Home/ComfyUI/ConsoleComfyUILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import BriaButtonGroup from "../../../components/common/BriaButtonGroup/BriaButtonGroup";
import LinkConstants from "../../../constants/LinkConstants";

const ProductShotComfyUI = () => {
	const { t } = useTranslation("translation", { keyPrefix: "productShot.comfyUI" });

	const openDocs = (link: string) => window.open(link, "_blank");

	const productShotApiCards: ConsoleAPICardProps[] = [
		{
			image: LifestyleByTextImage,
			header: t("cards.lifestyleByText.header"),
			description: t("cards.lifestyleByText.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.LIFESTYLE_BY_TEXT.COMFY_UI.NODE)}
					>
						{t("cards.lifestyleByText.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.LIFESTYLE_BY_TEXT.COMFY_UI.WORKFLOW)}
					>
						{t("cards.lifestyleByText.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		{
			image: LifestyleByImageImage,
			header: t("cards.lifestyleByImage.header"),
			description: t("cards.lifestyleByImage.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.LIFESTYLE_BY_IMAGE.COMFY_UI.NODE)}
					>
						{t("cards.lifestyleByImage.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.LIFESTYLE_BY_IMAGE.COMFY_UI.WORKFLOW)}
					>
						{t("cards.lifestyleByImage.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
	];

	return (
		<ConsoleComfyUILayout description={t("description")}>
			<ConsoleAPICards cards={productShotApiCards} />
		</ConsoleComfyUILayout>
	);
};

export default observer(ProductShotComfyUI);
